import ViewQuizSubmissionLayout from 'components/ViewQuizSubmission/ViewQuizSubmissionLayout';

const Desktop = (props) => <ViewQuizSubmissionLayout device={'desktop'} {...props} />;

export default Desktop;
